import React from 'react';
import PropTypes from 'prop-types';

import { getTimeZones } from 'utils/date';
import Select from 'components/Select';

const mapOption = (text) => ({
  label: text,
  value: text,
});

const options = getTimeZones();

class TimezoneDropdown extends React.PureComponent {
  handleChange = ({ value }) => {
    this.props.onChange(value);
  };

  render() {
    const { value } = this.props;
    return (
      <Select
        options={options.map(mapOption)}
        placeholder="Select Time Zone"
        value={value ? mapOption(value) : null}
        onChange={this.handleChange}
        label="Time Zone"
      />
    );
  }
}

TimezoneDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default TimezoneDropdown;
